import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgFingerDrop = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M2.625 7.625L6.9775 3.2725C7.39416 2.86915 7.95267 2.64574 8.53257 2.65045C9.11246 2.65516 9.66727 2.88761 10.0773 3.29767C10.4874 3.70773 10.7198 4.26254 10.7246 4.84243C10.7293 5.42233 10.5058 5.98084 10.1025 6.3975L8.875 7.625H18.875C19.538 7.625 20.1739 7.8884 20.6428 8.35724C21.1116 8.82608 21.375 9.46196 21.375 10.125C21.375 10.788 21.1116 11.4239 20.6428 11.8928C20.1739 12.3616 19.538 12.625 18.875 12.625H12.625V13.875C12.625 15.2011 12.0982 16.4729 11.1605 17.4105C10.2229 18.3482 8.95108 18.875 7.625 18.875H2.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.125 18.875C20.125 19.538 19.8616 20.1739 19.3928 20.6428C18.9239 21.1116 18.288 21.375 17.625 21.375C16.962 21.375 16.3261 21.1116 15.8572 20.6428C15.3884 20.1739 15.125 19.538 15.125 18.875C15.125 17.4942 17.625 15.125 17.625 15.125C17.625 15.125 20.125 17.4942 20.125 18.875Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgFingerDrop.displayName = 'SvgFingerDrop';
export default SvgFingerDrop;
